const stepsArray = [
    {
        title: 'Physician Certification Form',
        desc: 'The first step to becoming a medicinal marijuana patient in Illinois is to meet with your doctor about medical marijuana. Your physician is required to fill out the Physician Certification Form and submit it via mail it to the Illinois Department of Health. Please note that you have 90 days from the date of submission to have your appointment with your doctor',
    },

    {
        title: 'Fill Out Patient Application',
        desc: 'As a potential medical marijuana patient, you must fill out the patient application in it’s entirety, except the caregiver portion if you do not have a caregiver'
    },

    {
        title: 'Pay the Application Fee',
        desc: 'There is a $100 for 1 year, $200 for 2 year, and $250 for 3 year non-refundable application fee for all patients interested in applying for the use of medicinal marijuana. If you are a veteran or enrolled in SSDI or SSI disability programs, the application fee is reduced to $50 for 1 year, $100 for 2 year, $125 for 3 year.'
    },

    {
        title: 'Photo',
        desc: 'In order to complete your application, you will need to send a 2×2 inch passport photo. It is important to make sure this photo is taken with a solid colored background with nobody else in the photo with you. The easiest option is to visit your local passport photo service location and have them take your photo.'
    },

    {
        title: 'Proof of Residency',
        desc: 'Along with your application and a photo, you will need to provide two forms of proof that you are an Illinois resident. Acceptable forms of proof include your driver’s license, voter card, bank statements or utility bills with your name and address on them.'
    },

    {
        title: 'Proof of Age and Identity',
        desc: 'You must also send in a photocopy of your government issued ID, such as a driver’s license, passport, or state ID.'
    },

    {
        title: 'Veterans',
        desc: 'If you are a veteran, you must submit a copy of your DD214 along with the reduced $50 application fee. If you receive medical treatment from the VA, you can have them send your medical records in lieu of the Physician Certification Form.'
    },

    {
        title: 'Caregivers',
        desc: 'If you are caregiver, you are required to fill out the Caregiver Application Form and send in the $25 caregiver application fee.'
    }
]

export default stepsArray;